import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { CoachDto } from "../../../models/coach/dto/coach.dto";

export const GET_COACH_QUERY_KEY = (id: string) => ['coach', id];
export const useGetCoach = (id: string) => {
    const apiClient = useApiClient();
    return useQuery({
        enabled: Boolean(id),
        queryKey: GET_COACH_QUERY_KEY(id),
        queryFn: () => apiClient.fetchApi<CoachDto, {}>({ method: 'GET', endpoint: `coachs/${id}` })
    });
};